import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Constants
import { EMPTY_STATUS_ACTIONS_CONSTANTS } from '../../../../components/empty-status/components/empty-status-actions/constants/empty-status-actions.constants';
// Styles
import { EmptyStatusActionsWrapperStyled } from '../../../../components/empty-status/empty-status.component.styled';
// Types
import { ButtonComponent } from '../../../../components/button/button.component';
import { LinkComponent } from '../../../../components/link/link.component';
const EmptyStatusActionsComponent = ({ link, mainButton, secondaryButton, styles, }) => {
    return (_jsxs(EmptyStatusActionsWrapperStyled, { styles: styles, children: [mainButton?.children && (_jsx(ButtonComponent, { ...mainButton, ...EMPTY_STATUS_ACTIONS_CONSTANTS.MAIN_BUTTON_PROPS })), secondaryButton?.children && (_jsx(ButtonComponent, { ...secondaryButton, ...EMPTY_STATUS_ACTIONS_CONSTANTS.SECONDARY_BUTTON_PROPS })), link?.children && _jsx(LinkComponent, { ...link })] }));
};
export { EmptyStatusActionsComponent };
//# sourceMappingURL=empty-status-actions.component.js.map